import { defineMessages } from 'react-intl';

export const scope = 'app.components.transactions.filters';

export default defineMessages({
  filters_button: {
    id: `${scope}.filters_button`,
    defaultMessage: 'Filters',
  },
  filter: {
    id: `${scope}.filter`,
    defaultMessage: 'Filter',
  },
  customize_view: {
    id: `${scope}.customize_view`,
    defaultMessage: 'Customize your view by selectively including or excluding table elements.',
  },
  transaction_id: {
    id: `${scope}.transaction_id`,
    defaultMessage: 'Transaction ID',
  },
  drive_enrollment_id: {
    id: `${scope}.drive_enrollment_id`,
    defaultMessage: 'Drive Enrollment ID',
  },
  attendee: {
    id: `${scope}.attendee`,
    defaultMessage: 'Attendee',
  },
  workflow: {
    id: `${scope}.workflow`,
    defaultMessage: 'Workflow',
  },
  transaction_action: {
    id: `${scope}.transaction_action`,
    defaultMessage: 'Transaction Action',
  },
  transaction_date: {
    id: `${scope}.transaction_date`,
    defaultMessage: 'Transaction Date',
  },
  code: {
    id: `${scope}.code`,
    defaultMessage: 'Voucher Code',
  },
  country_of_residence: {
    id: `${scope}.country_of_residence`,
    defaultMessage: 'Country of Residence',
  },
  invoice_id: {
    id: `${scope}.invoice_id`,
    defaultMessage: 'Invoice ID',
  },

  status: {
    id: `${scope}.status`,
    defaultMessage: 'Status',
  },
  select_workflow: {
    id: `${scope}.select_workflow`,
    defaultMessage: 'Select workflows',
  },
  select_transaction_action: {
    id: `${scope}.select_transaction_action`,
    defaultMessage: 'Select transaction action',
  },
  clear: {
    id: `${scope}.clear`,
    defaultMessage: 'Clear Filters',
  },
  apply: {
    id: `${scope}.apply`,
    defaultMessage: 'Apply',
  },
  select_status: {
    id: `${scope}.select_status`,
    defaultMessage: 'Select status',
  },
  select_country: {
    id: `${scope}.select_country`,
    defaultMessage: 'Select country',
  },
  search_for_workflow: {
    id: `${scope}.search_for_workflow`,
    defaultMessage: 'Search for workflows',
  },
  search_for_transaction_id: {
    id: `${scope}.search_for_transaction_id`,
    defaultMessage: 'Search for Transaction IDs',
  },
  search_for_drive_enrollment_id: {
    id: `${scope}.search_for_drive_enrollment_id`,
    defaultMessage: 'Search for Drive Enrollment IDs',
  },
  search_for_attendee: {
    id: `${scope}.search_for_attendee`,
    defaultMessage: 'Search for attendees',
  },
  search_for_voucher_code: {
    id: `${scope}.search_for_voucher_code`,
    defaultMessage: 'Search for voucher codes',
  },
  search_for_invoice_id: {
    id: `${scope}.search_for_invoice_id`,
    defaultMessage: 'Search for invoice ID',
  },
});
